/**
 * サンプルクラス
 * @constructor
 */
class RecruitSecondaryHeader {

  constructor() {

    this.lassName = '.l-header--recruitSecondary'; // クラスのCSSクラス名
    this._addClassNameVal = 'l-header--recruitSecondary'; // 追加するCSSクラス名

    this.init();
  }
  /**
  * 初期化メソッド
  * ページ内に指定された要素（.l-header--recruitSecondary）が存在する場合に実行する
   */
  init() {
    if (document.querySelector(this.lassName)) {
      // 指定されたCSSクラス名の要素が存在する場合、監視を開始する
      this.makeObserver_header(this.lassName);
    }
  }

  /**
   * IntersectionObserverを使用して、要素の表示状態を監視し、CSSクラスを追加・削除するメソッド
   * @param {string} targetClassName - 監視対象の要素のCSSクラス名
   */
  makeObserver_header(targetClassName) {
    const border = 100; // ターゲット要素が画面内に入る前にトリガーする距離
    const targetItem = document.querySelector(targetClassName); // 監視対象の要素を取得
    const target = document.body; // htmlのbodyを取得
    const addClassNameval = this._addClassNameVal; // 追加するCSSクラス名
    const spHeaderScroll_options = {
      root: null, // ルート（親要素）はビューポート（画面内）
      rootMargin: `${border}px 0px ${target.clientHeight}px 0px`, // マージン設定
      threshold: 1 // ターゲット要素が100%表示されたらコールバックを呼び出す
    };

    // IntersectionObserverを作成し、監視を開始
    const spHeaderScroll_Observer = new IntersectionObserver(targetAddClass, spHeaderScroll_options);
    spHeaderScroll_Observer.observe(target);

    // IntersectionObserverのコールバック関数
    function targetAddClass (entries) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // ターゲット要素が画面内に入った場合、指定のCSSクラスを追加
          targetItem.classList.add(addClassNameval);
        } else {
          // ターゲット要素が画面外に出た場合、指定のCSSクラスを削除
          targetItem.classList.remove(addClassNameval);
        }
      });
    }
  }
}

export default RecruitSecondaryHeader;
